// src/components/Attractions.js
import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { FaGamepad, FaUtensils, FaCouch, FaUsers } from "react-icons/fa";
import { GiPerspectiveDiceSixFacesRandom } from "react-icons/gi";

const attractions = [
  {
    icon: <FaGamepad />,
    title: "Console Gaming",
    description: "Experience the latest PlayStation and Xbox games on high-definition screens with comfortable gaming chairs."
  },
  {
    icon: <GiPerspectiveDiceSixFacesRandom />,
    title: "Board Game Corner",
    description: "Challenge friends with our collection of over 100 board games ranging from classics to modern strategy games."
  },
  {
    icon: <FaUtensils />,
    title: "Gaming Café",
    description: "Refuel with delicious snacks, gourmet burgers, pizzas, and refreshing drinks while taking a break from gaming."
  },
  {
    icon: <FaCouch />,
    title: "Parents' Lounge",
    description: "A comfortable area for parents to relax with free Wi-Fi, premium coffee, and a view of the gaming zones."
  },
  {
    icon: <FaUsers />,
    title: "Party Rooms",
    description: "Private spaces for birthdays or events with custom packages, personalized service, and exclusive gaming access."
  }
];

const AttractionsSection = styled.section`
  background-color: #0a0a0a;
  position: relative;
  overflow: hidden;
  id: "attractions";

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 200px;
    background: linear-gradient(to top, #0a0a0a, transparent);
     &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 200px;
    background: linear-gradient(to top, #0a0a0a, transparent);
    pointer-events: none;
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  
  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 0 20px;
  }
`;

const Card = styled(motion.div)`
  background: rgba(20, 20, 20, 0.8);
  border-radius: 15px;
  padding: 30px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 153, 0, 0.1);
  transition: all 0.4s ease;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
  
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 10px 30px rgba(255, 153, 0, 0.2);
    border-color: rgba(255, 153, 0, 0.3);
  }
`;

const IconWrapper = styled.div`
  font-size: 40px;
  margin-bottom: 20px;
  color: #ff9900;
  background: rgba(255, 153, 0, 0.1);
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  box-shadow: 0 5px 15px rgba(255, 153, 0, 0.2);
`;

const Title = styled.h3`
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 15px;
  font-family: 'Orbitron', sans-serif;
  color: #ff9900;
  letter-spacing: 1px;
`;

const Description = styled.p`
  font-size: 16px;
  line-height: 1.6;
  color: #ccc;
`;

const Attractions = () => {
  return (
    <AttractionsSection id="attractions">
      <Container>
        <h2 className="section-title" data-aos="fade-up">More Attractions</h2>

        <Grid>
          {attractions.map((item, index) => (
            <Card
              key={index}
              data-aos="zoom-in"
              data-aos-delay={index * 100}
              whileHover={{ y: -10 }}
            >
              <IconWrapper>{item.icon}</IconWrapper>
              <Title>{item.title}</Title>
              <Description>{item.description}</Description>
            </Card>
          ))}
        </Grid>
      </Container>
    </AttractionsSection>
  );
};

export default Attractions;